import { ibanFormats } from './ibanFormats';

/* global BigInt */

export function generateIban(countryCode) {
    const format = ibanFormats[countryCode];
    if (!format) {
        return 'IBAN will appear here after generating';
    }

    const bban = generateBBAN(format.bban);
    const checkDigits = calculateCheckDigits(countryCode, bban);
    return countryCode + checkDigits + bban;
}

function generateBBAN(structure) {
    return structure.map(({ type, length, value }) => {
        if (type === 'fixed') return value;

        const chars = type === 'n' ? '0123456789'
            : type === 'a' ? 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
                : 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';

        return Array.from({ length }, () =>
            chars.charAt(Math.floor(Math.random() * chars.length))
        ).join('');
    }).join('');
}


function calculateCheckDigits(countryCode, bban) {
    const rearranged = bban + countryCode + '00';
    const numeric = rearranged.split('').map(char => {
        return isNaN(char) ? (char.charCodeAt(0) - 55).toString() : char;
    }).join('');
    const checksum = 98n - (BigInt(numeric) % 97n);
    return checksum.toString().padStart(2, '0');
}
